import { Avatar } from '../Avatar';

/** The coach's photo on the booking screens: the shared Avatar (components.md 4), 48 by default here. */
export const CoachPhoto = Avatar;

export function CoachHeader({ photoUrl, coachName, title, line }: {
  photoUrl?: string | null; coachName: string; title: string; line?: React.ReactNode;
}) {
  return (
    <div className="flex items-center gap-3">
      <CoachPhoto url={photoUrl} name={coachName} size={48} />
      <div className="min-w-0">
        <h1 className="text-[17px] leading-[22px] font-semibold tracking-[-0.43px] text-db-text-1">{title}</h1>
        {line && <p className="mt-0.5 text-[15px] leading-[20px] text-db-text-2">{line}</p>}
      </div>
    </div>
  );
}
